import classnames from "classnames";
import { usePagination, DOTS } from "./usePagination";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";

const Pagination = (props) => {
  const {
    onPageChange,
    totalCount,
    siblingCount = 1,
    currentPage,
    pageSize,
    className,
  } = props;

  const paginationRange = usePagination({
    currentPage,
    totalCount,
    siblingCount,
    pageSize,
  });

  // If there are less than 2 times in pagination range we shall not render the component
  if (currentPage === 0 || paginationRange.length < 2) {
    return null;
  }

  const onNext = () => {
    onPageChange(currentPage + 1);
  };

  const onPrevious = () => {
    onPageChange(currentPage - 1);
  };

  let lastPage = paginationRange[paginationRange.length - 1];
  return (
    <div className={classnames("btn-group", { [className]: className })}>
      {/* Left navigation arrow */}
      <button
        className={classnames("btn")}
        disabled={currentPage === 1}
        onClick={() => {
          onPrevious();
        }}
      >
        <FaArrowLeft />
      </button>
      {paginationRange.map((pageNumber, index) => {
        // If the pageItem is a DOT, render the DOTS unicode character
        if (pageNumber === DOTS) {
          return (
            <button key={index} className="btn btn-disabled">
              &#8230;
            </button>
          );
        }

        // Render our Page Pills
        return (
          <button
            key={index}
            className={classnames("btn", {
              "btn-active": pageNumber === currentPage,
            })}
            onClick={() => onPageChange(pageNumber)}
          >
            {pageNumber}
          </button>
        );
      })}
      {/*  Right Navigation arrow */}
      <button
        className={classnames("btn")}
        disabled={currentPage === lastPage}
        onClick={() => {
          onNext();
        }}
        data-cy="nextProductsPagination"
      >
        <FaArrowRight />
      </button>
    </div>
  );
};

export default Pagination;
